<div *ngIf="plainTextDescription" class="description">
  <markdown>{{ plainTextDescription }}</markdown>
</div>
<smart-fix-video-preview
  *ngIf="plainTextDescription"
  [messageText]="plainTextDescription"
></smart-fix-video-preview>
